import { Link } from 'react-router-dom';
import { useTranslation } from '@wlb/shared/i18n/useTranslation';
import { BrandLogo } from '../components/ui/BrandLogo';
import { AuthFlowLayout } from '../components/layout/AuthFlowLayout';

export function PasswordResetSuccess() {
  const { t } = useTranslation();

  return (
    <AuthFlowLayout>
      <div className="auth-flow__card">
        <BrandLogo compact className="auth-flow__brand" />
        <h1 className="auth-flow__heading">{t('auth.passwordResetSuccess.heading')}</h1>
        <p className="auth-flow__subheading">{t('auth.passwordResetSuccess.subheading')}</p>
        <Link to="/login" className="auth-flow__primary auth-flow__primary--link">
          {t('auth.passwordResetSuccess.backToSignIn')}
        </Link>
      </div>
    </AuthFlowLayout>
  );
}
